module.exports = __webpack_public_path__ + "img/item_red.7ab327de.png";